import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import tradetronWelcome from "./../../../Images/tradetronWelcome.png";
import AlgoBulls from './../../../Images/tools/algo-trading/single-page/AlgoBulls.png'
import "./AlgoBullsWelcome.css";
function AlgoBullsWelcome(props) {
  //console.log(props);
  return (
    <>
      <section className="algobullswelcome_section">
        <Container>
          <Row>
            <Col md={7}>
              <div>
                <h3>{props.data.title}</h3>
                <p>{props.data.content1}</p>
                <p>{props.data.content2}</p>
              </div>
            </Col>
            <Col md={5}>
              <div className="AlgoBullsWelcome_img pl-3">
                <img
                  className="img-fluid"
                  src={AlgoBulls}
                  alt="AlgoBulls"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default AlgoBullsWelcome;
